import { HotspotTypeEnum } from './hotspot.types.enum';
import { HotspotThemesEnum } from './hotspot.themes.enum';
import { ContentBlock } from 'src/app/content-blocks/models/content-block';
import { vec3 } from 'gl-matrix';

export class HotspotModel {
  // positioning ================================================
  pos?: vec3;
  primitiveIndex?: number;
  barycentric?: vec3;
  renderableIndex?: number;
  dir: vec3;
  objectId: string;

  // styling ====================================================
  shown: boolean;
  type: HotspotTypeEnum;
  symbol: string;
  className: string; // e.g. "circle minus label"
  theme?: HotspotThemesEnum;

  // actions ===================================================
  actionSrc?: string;
  actions?: string[];

  // label properties ==========================================
  title?: string;
  description?: string;
  labelOffset?: [number, number];

  // Content Blocks
  contentBlocks?: ContentBlock[];
}
